import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface EmptyStateProps {
  icon?: LucideIcon;
  emoji?: string;
  title: string;
  description?: string;
  /** Optional action button(s) */
  action?: React.ReactNode;
  className?: string;
}

/**
 * Consistent empty state with icon, title, description, and optional action.
 */
export function EmptyState({
  icon: Icon,
  emoji,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <Card className={cn('gd-panel', className)}>
      <div className="gd-empty flex flex-col items-center justify-center">
        {Icon && (
          <div className="rounded-full bg-primary/10 p-4 mb-4">
            <Icon className="h-10 w-10 text-primary" />
          </div>
        )}
        {emoji && (
          <div className="text-4xl mb-4">{emoji}</div>
        )}
        <h3 className="font-display text-2xl font-semibold mb-3 break-words">{title}</h3>
        {description && (
          <p className="text-muted-foreground text-sm max-w-lg mb-4">{description}</p>
        )}
        {action && <div className="mt-2">{action}</div>}
      </div>
    </Card>
  );
}
